/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geowindow301Inputs */

const en_geowindow301 = /** @type {(inputs: Geowindow301Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 days`)
};

const de_geowindow301 = /** @type {(inputs: Geowindow301Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 Tage`)
};

/**
* | output |
* | --- |
* | "30 days" |
*
* @param {Geowindow301Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geowindow301 = /** @type {((inputs?: Geowindow301Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geowindow301Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geowindow301(inputs)
	return de_geowindow301(inputs)
});
export { geowindow301 as "geoWindow30" }